import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axios";
import loadStatus from "../util/loadStatus";

export const getProjects = createAsyncThunk(
  "projects/getProjects",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().projects;

      if (state.count.getProjects <= 1) {
        const res = await axios.get("/projects", { params: reqData });
        return res.data;
      }
      return { data: state.data, count: state.total };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getAssigneeProjects = createAsyncThunk(
  "projects/getAssigneeProjects",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().projects;

      if (state.count.getAssigneeProjects <= 1) {
        const res = await axios.get("/projects/assignee", { params: reqData });
        return res.data;
      }
      return { data: state.data, count: state.total };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getProjectRequests = createAsyncThunk(
  "projects/getProjectRequests",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      let res;

      const state = getState().projects;
      if (state.count.getProjectRequests <= 1) {
        if (reqData.desk === "volunteer") {
          res = await axios.get(
            "/user-requests/" + reqData.id + "/" + reqData.community_id,
            { params: reqData }
          );
        } else if (reqData.desk === "community") {
          res = await axios.get(
            "/community-reviews/" + reqData.id + "/" + reqData.community_id,
            { params: reqData }
          );
        } else if (reqData.desk === "provincial") {
          res = await axios.get("/provincial-reviews/" + reqData.id, {
            params: { limit: reqData.limit, offet: reqData.offset },
          });
        } else if (reqData.desk === "pdo") {
          res = await axios.get("/pdo-reviews/" + reqData.id, {
            params: { limit: reqData.limit, offet: reqData.offset },
          });
        } else if (reqData.desk === "economer") {
          res = await axios.get("/economer-reviews/" + reqData.id, {
            params: { limit: reqData.limit, offet: reqData.offset },
          });
        } else if (reqData.desk === "accounts") {
          res = await axios.get("/projects/accounts/" + reqData.id, {
            params: { limit: reqData.limit, offet: reqData.offset },
          });
        } else if (reqData.desk === "proposal") {
          res = await axios.get(
            `/projects/proposals/${reqData.desk}/${reqData.id}`,
            {
              params: { limit: reqData.limit, offet: reqData.offset },
            }
          );
        } else if (reqData.desk === "reformulation") {
          res = await axios.get("/projects/reformulations/" + reqData.id, {
            params: { limit: reqData.limit, offet: reqData.offset },
          });
        }
        //Return the
        return res.data;
      }
      return { data: state.data, count: state.total };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getProjectsByTerm = createAsyncThunk(
  "projects/getProjectsByTerm",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().projects;
      if (state.count.getProjectsByTerm <= 1) {
        const res = await axios.get("/projects-term", {
          params: { term: reqData },
        });
        return res.data.data;
      }
      return state.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getActiveProjectsByTerm = createAsyncThunk(
  "projects/getActiveProjectsByTerm",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().projects;
      if (state.count.getActiveProjectsByTerm <= 1) {
        const res = await axios.get("/projects-term", {
          params: { term: reqData },
        });
        const data = res.data.data.filter(
          (item) => item.status.toLowerCase() === "active"
        );
        return data;
      }
      return state.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getCanceledProjects = createAsyncThunk(
  "projects/getCanceledProjects",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().projects;
      if (state.count.getCanceledProjects <= 1) {
        const res = await axios.get("/canceled-projects", { params: reqData });
        return res.data;
      }
      return { data: state.data, count: state.total };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getProjectReports = createAsyncThunk(
  "projects/getProjectReports",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().projects;
      if (state.count.getProjectReports <= 1) {
        const res = await axios.get("/project-reports", {
          params: reqData,
        });
        return res.data;
      }
      return { data: state.data, count: state.total };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getOrganizationProjects = createAsyncThunk(
  "projects/getOrganizationProjects",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().projects;
      if (state.count.getProjects <= 1) {
        const res = await axios.get("/organization-projects/" + reqData, {
          params: reqData,
        });
        return res.data;
      }
      return { data: state.data, count: state.total };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getProjectReport = createAsyncThunk(
  "projects/getProjectReport",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().projects;
      if (state.data.length <= 0 && state.count.getProjectReport <= 1) {
        const res = await axios.get("/project-report/" + reqData, {
          params: reqData,
        });
        return res.data;
      }
      return state.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getCommunityProjects = createAsyncThunk(
  "projects/getCommunityProjects",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().projects;
      if (state.count.getProjects <= 1) {
        const res = await axios.get("/community-projects/" + reqData, {
          params: reqData,
        });
        return res.data;
      }
      return { data: state.data, count: state.total };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getProject = createAsyncThunk(
  "project/getProject",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const selected = getState().projects.selected;
      const count = getState().projects.count.getProject;
      if (count <= 1) {
        const res = await axios.get("/project/" + reqData);
        return res.data;
      }
      return selected;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getOnlyProject = createAsyncThunk(
  "project/getOnlyProject",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const selected = getState().projects.selected;
      const count = getState().projects.count.getOnlyProject;
      if (count <= 1) {
        const res = await axios.get("/projects/only-project/" + reqData);
        return res.data;
      }
      return selected;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getProjectWithMails = createAsyncThunk(
  "project/getProjectWithMails",
  async ({ project_id, donor_id, data }, { rejectWithValue, getState }) => {
    try {
      const selected = getState().projects.selected;
      const count = getState().projects.count.getProjectWithMails;
      if (count <= 1) {
        const res = await axios.get(
          "/project/emails/" + project_id + "/" + donor_id,
          {
            params: data,
          }
        );

        return res.data;
      }
      return selected;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getProjectReportById = createAsyncThunk(
  "project/getProjectReportById",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.get("/project-report/" + reqData);

      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getPartialProject = createAsyncThunk(
  "projects/getPartialProject",
  async (reqData, { rejectWithValue, getState }) => {
    const state = getState().projects;
    try {
      if (state.count.getPartialProject <= 1) {
        const res = await axios.get("/partial-project");

        return res.data;
      }
      return state.selected;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProject = createAsyncThunk(
  "projects/addProject",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      let res;
      if (reqData.step === 1) {
        res = await axios.post("/add-project-step-one", reqData);
      } else if (reqData.step === 2) {
        res = await axios.post("/add-project-step-two", reqData);
      } else if (reqData.step === 3) {
        res = await axios.post("/add-project-step-three", reqData);
      } else if (reqData.step === 4) {
        res = await axios.post("/add-project-step-four", reqData);
      } else if (reqData.step === 5) {
        res = await axios.post("/add-project-step-five", reqData);
      }
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addBeneficiaryProfile = createAsyncThunk(
  "projects/addBeneficiaryProfile",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-beneficiary-profile", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProblemStatement = createAsyncThunk(
  "projects/addProblemStatement",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-problem-statement", reqData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProblemStatementSummary = createAsyncThunk(
  "projects/addProblemStatementSummary",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-problem-statement-summary", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addCommunityApprove = createAsyncThunk(
  "projects/addCommunityApprove",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-community-approve", reqData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addCommunityReject = createAsyncThunk(
  "projects/addCommunityReject",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-community-reject", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addCommunityTotalReject = createAsyncThunk(
  "projects/addCommunityTotalReject",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-community-total-reject", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProvincialReqApprove = createAsyncThunk(
  "projects/addProvincialReqApprove",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-provincial-request-approve", reqData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProvincialReqReject = createAsyncThunk(
  "projects/addProvincialReqReject",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-provincial-request-reject", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProvincialTotalReqReject = createAsyncThunk(
  "projects/addProvincialTotalReqReject",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        "/add-provincial-request-total-reject",
        reqData
      );
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addPDOLetter = createAsyncThunk(
  "projects/addPDOLetter",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-pdo-confirmation", reqData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

//Phase Two
/**
 *
 *
 * Proposal
 */

export const addProposalPhase = createAsyncThunk(
  "projects/addProposalPhase",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-proposal-phase", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProposalBasics = createAsyncThunk(
  "projects/addProposalBasics",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-proposal-basics", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProposalBackground = createAsyncThunk(
  "projects/addProposalBackground",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-proposal-background", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProposalDetails = createAsyncThunk(
  "projects/addProposalDetails",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-proposal-details", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProposalIssues = createAsyncThunk(
  "projects/addProposalIssues",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-proposal-issues", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProposalBudget = createAsyncThunk(
  "projects/addProposalBudget",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-proposal-budget", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProposalSummary = createAsyncThunk(
  "projects/addProposalSummary",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-proposal-summary", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

/**
 *
 *
 *
 * Proposal Approvals
 */

export const addCommunityProposalApprove = createAsyncThunk(
  "projects/addCommunityProposalApprove",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-community-proposal-approve", reqData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addCommunityProposalReject = createAsyncThunk(
  "projects/addCommunityProposalReject",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-community-proposal-reject", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addCommunityProposalTotalReject = createAsyncThunk(
  "projects/addCommunityProposalTotalReject",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        "/add-community-proposal-total-reject",
        reqData
      );
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProvincialProposalApprove = createAsyncThunk(
  "projects/addProvincialProposalApprove",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        "/add-provincial-proposal-approve",
        reqData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProvincialProposalReject = createAsyncThunk(
  "projects/addProvincialProposalReject",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-provincial-proposal-reject", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProvincialProposalTotalReject = createAsyncThunk(
  "projects/addProvincialProposalTotalReject",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        "/add-provincial-proposal-total-reject",
        reqData
      );
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addPDOProposalApprove = createAsyncThunk(
  "projects/addPDOProposalApprove",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-pdo-proposal-approve", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addPDOProposalReject = createAsyncThunk(
  "projects/addPDOProposalReject",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-pdo-proposal-reject", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const approveProject = createAsyncThunk(
  "projects/approveProject",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.put("/approve-project/" + reqData.id, reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const editProject = createAsyncThunk(
  "projects/editProject",
  async ({ id, reqData }, { rejectWithValue }) => {
    try {
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const cancelProject = createAsyncThunk(
  "projects/cancelProject",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.put("/cancel-project/" + reqData.id, reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const deleteProject = createAsyncThunk(
  "projects/deleteProject",
  async ({ id, reqData }, { rejectWithValue }) => {
    try {
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

/**
 *
 *
 * Reformulation
 *
 */
export const donorProposalEmail = createAsyncThunk(
  "projects/donorProposalEmail",
  async ({ donor_id, project_id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        "/projects/donors/proposal-email/" + project_id + "/" + donor_id,
        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const donorProposalEmailRecord = createAsyncThunk(
  "projects/donorProposalEmailRecord",
  async ({ donor_id, project_id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        "/projects/donors/proposal-email-record/" + project_id + "/" + donor_id,
        data
      );
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const donorProposalFollowUpEmail = createAsyncThunk(
  "projects/donorProposalFollowUpEmail",
  async ({ donor_id, project_id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        "/projects/donors/proposal-email-follow/" + project_id + "/" + donor_id,
        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const donorProposalFollowUpEmailRecord = createAsyncThunk(
  "projects/donorProposalFollowUpEmailRecord",
  async ({ donor_id, project_id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        "/projects/donors/proposal-email-follow-record/" +
          project_id +
          "/" +
          donor_id,
        data
      );
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const donorProposalEmailCompleted = createAsyncThunk(
  "projects/donorProposalEmailCompleted",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        "/projects/donors/proposal-email-completed/" + reqData
      );
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const donorProposalFollowUpEmailCompleted = createAsyncThunk(
  "projects/donorProposalFollowUpEmailCompleted",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        "/projects/donors/proposal-email-follow-completed/" + reqData
      );
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const putIncludeDonor = createAsyncThunk(
  "donors/putIncludeDonor",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put("/projects/include-donors/" + id, data);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addProjectExpenses = createAsyncThunk(
  "donors/addProjectExpenses",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put("/projects/add-expense-items/" + id, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const saveDonorAgreements = createAsyncThunk(
  "donors/saveDonorAgreements",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.post("/projects/save-agreements/" + id, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

const projectsSlice = createSlice({
  name: "projects",
  initialState: {
    total: 0,
    size: 10,
    limit: 0,
    data: [],
    incomes: [],
    expenses: [],
    selected: {},
    loading: false,
    step: -1,
    error: null,
    load: {
      getProjects: false,
      getAssigneeProjects: false,
      getProjectsByTerm: false,
      getActiveProjectsByTerm: false,
      getProject: false,
      getOnlyProject: false,
      getProjectWithMails: false,
      getProjectReportById: false,
      getProjectRequests: false,
      getCanceledProjects: false,
      getPartialProject: false,
      getProjectReports: false,
      approveProject: false,
      addProject: false,
      editProject: false,
      deleteProject: false,
      cancelProject: false,
      addBeneficiaryProfile: false,
      addProblemStatement: false,
      addProblemStatementSummary: false,
      addCommunityApprove: false,
      addCommunityReject: false,
      addCommunityTotalReject: false,
      addProvincialReqApprove: false,
      addProvincialReqReject: false,
      addProvincialTotalReqReject: false,
      addPDOLetter: false,
      addProposalPhase: false,
      addProposalBasics: false,
      addProposalBackground: false,
      addProposalDetails: false,
      addProposalIssues: false,
      addProposalBudget: false,
      addProposalSummary: false,
      addCommunityProposalApprove: false,
      addCommunityProposalReject: false,
      addCommunityProposalTotalReject: false,
      addProvincialProposalApprove: false,
      addProvincialProposalReject: false,
      addProvincialProposalTotalReject: false,
      addPDOProposalApprove: false,
      addPDOProposalReject: false,
      addPDOProposalReject: false,
      donorProposalEmail: false,
      donorProposalEmailRecord: false,
      donorProposalFollowUpEmail: false,
      donorProposalFollowUpEmailRecord: false,
      donorProposalEmailCompleted: false,
      donorProposalFollowUpEmailCompleted: false,
      putIncludeDonor: false,
      saveDonorAgreements: false,
      addProjectExpenses: false,
    },
    count: {
      getProjects: 0,
      getAssigneeProjects: 0,
      getProjectsByTerm: 0,
      getActiveProjectsByTerm: 0,
      getProject: 0,
      getOnlyProject: 0,
      getProjectReportById: 0,
      getProjectRequests: 0,
      getPartialProject: 0,
      getCanceledProjects: 0,
      getProjectReports: 0,
      addBeneficiaryProfile: 0,
      addProblemStatement: 0,
      addProblemStatementSummary: 0,
      addCommunityApprove: 0,
      addCommunityReject: 0,
      addProvincialReqApprove: 0,
      addProvincialReqReject: 0,
      addPDOLetter: 0,
      addProposalPhase: 0,
      addProposalBasics: 0,
      addProposalBackground: 0,
      addProposalDetails: 0,
      addProposalIssues: 0,
      addProposalBudget: 0,
      addProposalSummary: 0,
      putIncludeDonor: 0,
      saveDonorAgreements: 0,
    },
  },
  reducers: {
    setProjects: (state, action) => {
      state.data = action.payload;
    },
    setSelectedProject: (state, action) => {
      state.selected = action.payload;
    },
    setProjectsSize: (state, action) => {
      state.size = action.payload;
    },
    unsetProjects: (state) => {
      state.data = [];
      state.selected = {};
      state.incomes = [];
      state.expenses = [];
      state.step = -1;
      state.dataLoaded = false;
    },
    unsetSelectedProject: (state) => {
      state.selected = {};
      state.step = -1;
    },
    setStep: (state, action) => {
      state.step = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      //Get all Projects
      .addCase(getProjects.pending, (state) => {
        state.load.getProjects = loadStatus.loading;
        state.error = null;
        state.count.getProjects = ++state.count.getProjects;
      })
      .addCase(getProjects.fulfilled, (state, action) => {
        state.load.getProjects = loadStatus.success;
        state.data = action.payload.data;
        state.total = action.payload.count;
        state.count.getProjects = 0;
      })
      .addCase(getProjects.rejected, (state, action) => {
        state.load.getProjects = loadStatus.error;
        state.error = action.error;
        state.count.getProjects = 0;
      })
      //Get all Assignee Projects
      .addCase(getAssigneeProjects.pending, (state) => {
        state.load.getAssigneeProjects = loadStatus.loading;
        state.error = null;
        state.count.getAssigneeProjects = ++state.count.getAssigneeProjects;
      })
      .addCase(getAssigneeProjects.fulfilled, (state, action) => {
        state.load.getAssigneeProjects = loadStatus.success;
        state.data = action.payload.data;
        state.total = action.payload.count;
        state.count.getAssigneeProjects = 0;
      })
      .addCase(getAssigneeProjects.rejected, (state, action) => {
        state.load.getAssigneeProjects = loadStatus.error;
        state.error = action.error;
        state.count.getAssigneeProjects = 0;
      })
      //Get all Projects by Term
      .addCase(getProjectsByTerm.pending, (state) => {
        state.load.getProjectsByTerm = loadStatus.loading;
        state.error = null;
        state.count.getProjectsByTerm = ++state.count.getProjectsByTerm;
      })
      .addCase(getProjectsByTerm.fulfilled, (state, action) => {
        state.load.getProjectsByTerm = loadStatus.success;
        // state.data = action.payload;
        // state.total = action.payload.count;
        state.count.getProjectsByTerm = 0;
      })
      .addCase(getProjectsByTerm.rejected, (state, action) => {
        state.load.getProjectsByTerm = loadStatus.error;
        state.error = action.error;
        state.count.getProjectsByTerm = 0;
      })
      //Get all Active Projects by Term
      .addCase(getActiveProjectsByTerm.pending, (state) => {
        state.load.getActiveProjectsByTerm = loadStatus.loading;
        state.error = null;
        state.count.getActiveProjectsByTerm = ++state.count
          .getActiveProjectsByTerm;
      })
      .addCase(getActiveProjectsByTerm.fulfilled, (state, action) => {
        state.load.getActiveProjectsByTerm = loadStatus.success;
        // state.data = action.payload;
        // state.total = action.payload.count;
        state.count.getActiveProjectsByTerm = 0;
      })
      .addCase(getActiveProjectsByTerm.rejected, (state, action) => {
        state.load.getActiveProjectsByTerm = loadStatus.error;
        state.error = action.error;
        state.count.getActiveProjectsByTerm = 0;
      })
      //Get all Project Requests
      .addCase(getProjectRequests.pending, (state) => {
        state.load.getProjectRequests = loadStatus.loading;
        state.dataLoaded = loadStatus.loading;
        state.error = null;
        state.count.getProjectRequests = ++state.count.getProjectRequests;
      })
      .addCase(getProjectRequests.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.total = action.payload.count;
        state.load.getProjectRequests = loadStatus.success;
        state.count.getProjectRequests = 0;
      })
      .addCase(getProjectRequests.rejected, (state, action) => {
        state.load.getProjectRequests = loadStatus.error;
        state.error = action.error;
        state.dataLoaded = loadStatus.error;
        state.count.getProjectRequests = 0;
      })
      //Get all Projects Reports
      .addCase(getProjectReports.pending, (state) => {
        state.load.getProjectReports = loadStatus.loading;
        state.error = null;
        state.count.getProjectReports = ++state.count.getProjectReports;
      })
      .addCase(getProjectReports.fulfilled, (state, action) => {
        state.load.getProjectReports = loadStatus.success;
        state.data = action.payload.data;
        state.total = action.payload.count;
        state.count.getProjectReports = 0;
      })
      .addCase(getProjectReports.rejected, (state, action) => {
        state.load.getProjectReports = loadStatus.error;
        state.error = action.error;
        state.count.getProjectReports = 0;
      })
      //Get all Canceled Projects
      .addCase(getCanceledProjects.pending, (state) => {
        state.load.getCanceledProjects = loadStatus.loading;
        state.error = null;
        state.count.getCanceledProjects = ++state.count.getCanceledProjects;
      })
      .addCase(getCanceledProjects.fulfilled, (state, action) => {
        state.load.getCanceledProjects = loadStatus.success;
        state.data = action.payload.data;
        state.total = action.payload.count;
        state.count.getCanceledProjects = 0;
      })
      .addCase(getCanceledProjects.rejected, (state, action) => {
        state.load.getCanceledProjects = loadStatus.error;
        state.error = action.error;
        state.count.getCanceledProjects = 0;
      })
      //Get  project
      .addCase(getProject.pending, (state) => {
        state.load.getProject = loadStatus.loading;
        state.error = null;
        state.count.getProject = ++state.count.getProject;
      })
      .addCase(getProject.fulfilled, (state, action) => {
        state.load.getProject = loadStatus.success;
        state.selected = action.payload;
        state.count.getProject = 0;
      })
      .addCase(getProject.rejected, (state, action) => {
        state.load.getProject = loadStatus.error;
        state.error = action.error;
        state.count.getProject = 0;
      })
      //Get  Only project
      .addCase(getOnlyProject.pending, (state) => {
        state.load.getOnlyProject = loadStatus.loading;
        state.error = null;
        state.count.getOnlyProject = ++state.count.getOnlyProject;
      })
      .addCase(getOnlyProject.fulfilled, (state, action) => {
        state.load.getOnlyProject = loadStatus.success;
        state.selected = action.payload;
        state.count.getOnlyProject = 0;
      })
      .addCase(getOnlyProject.rejected, (state, action) => {
        state.load.getOnlyProject = loadStatus.error;
        state.error = action.error;
        state.count.getOnlyProject = 0;
      })
      //Get  project with Mails
      .addCase(getProjectWithMails.pending, (state) => {
        state.load.getProjectWithMails = loadStatus.loading;
        state.error = null;
        state.count.getProjectWithMails = ++state.count.getProjectWithMails;
      })
      .addCase(getProjectWithMails.fulfilled, (state, action) => {
        state.load.getProjectWithMails = loadStatus.success;
        state.selected = action.payload;
        state.count.getProjectWithMails = 0;
      })
      .addCase(getProjectWithMails.rejected, (state, action) => {
        state.load.getProjectWithMails = loadStatus.error;
        state.error = action.error;
        state.count.getProjectWithMails = 0;
      })
      //Get  project Report
      .addCase(getProjectReportById.pending, (state) => {
        state.load.getProjectReportById = loadStatus.loading;
        state.error = null;
        state.count.getProjectReportById = ++state.count.getProjectReportById;
      })
      .addCase(getProjectReportById.fulfilled, (state, action) => {
        state.load.getProjectReportById = loadStatus.success;
        state.selected = action.payload;
        state.count.getProjectReportById = 0;
      })
      .addCase(getProjectReportById.rejected, (state, action) => {
        state.load.getProjectReportById = loadStatus.error;
        state.error = action.error;
        state.count.getProjectReportById = 0;
      })
      //Add Beneficiary Profile
      .addCase(addBeneficiaryProfile.pending, (state) => {
        state.load.addBeneficiaryProfile = loadStatus.loading;
        state.error = null;
      })
      .addCase(addBeneficiaryProfile.fulfilled, (state, action) => {
        state.load.addBeneficiaryProfile = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addBeneficiaryProfile.rejected, (state, action) => {
        state.load.addBeneficiaryProfile = loadStatus.error;
        state.error = action.error;
      })
      //Add Problem Statement
      .addCase(addProblemStatement.pending, (state) => {
        state.load.addProblemStatement = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProblemStatement.fulfilled, (state, action) => {
        state.load.addProblemStatement = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProblemStatement.rejected, (state, action) => {
        state.load.addProblemStatement = loadStatus.error;
        state.error = action.error;
      })
      //Add Problem Statement Summary
      .addCase(addProblemStatementSummary.pending, (state) => {
        state.load.addProblemStatementSummary = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProblemStatementSummary.fulfilled, (state, action) => {
        state.load.addProblemStatementSummary = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProblemStatementSummary.rejected, (state, action) => {
        state.load.addProblemStatementSummary = loadStatus.error;
        state.error = action.error;
      })
      //Add Community Approve
      .addCase(addCommunityApprove.pending, (state) => {
        state.load.addCommunityApprove = loadStatus.loading;
        state.error = null;
      })
      .addCase(addCommunityApprove.fulfilled, (state, action) => {
        state.load.addCommunityApprove = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addCommunityApprove.rejected, (state, action) => {
        state.load.addCommunityApprove = loadStatus.error;
        state.error = action.error;
      })
      //Add Community Reject
      .addCase(addCommunityReject.pending, (state) => {
        state.load.addCommunityReject = loadStatus.loading;
        state.error = null;
      })
      .addCase(addCommunityReject.fulfilled, (state, action) => {
        state.load.addCommunityReject = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addCommunityReject.rejected, (state, action) => {
        state.load.addCommunityReject = loadStatus.error;
        state.error = action.error;
      })
      //Add Community Total Reject
      .addCase(addCommunityTotalReject.pending, (state) => {
        state.load.addCommunityTotalReject = loadStatus.loading;
        state.error = null;
      })
      .addCase(addCommunityTotalReject.fulfilled, (state, action) => {
        state.load.addCommunityTotalReject = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addCommunityTotalReject.rejected, (state, action) => {
        state.load.addCommunityTotalReject = loadStatus.error;
        state.error = action.error;
      })
      //Add Provincial Approve
      .addCase(addProvincialReqApprove.pending, (state) => {
        state.load.addProvincialReqApprove = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProvincialReqApprove.fulfilled, (state, action) => {
        state.load.addProvincialReqApprove = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProvincialReqApprove.rejected, (state, action) => {
        state.load.addProvincialReqApprove = loadStatus.error;
        state.error = action.error;
      })
      //Add Provincial Reject
      .addCase(addProvincialReqReject.pending, (state) => {
        state.load.addProvincialReqReject = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProvincialReqReject.fulfilled, (state, action) => {
        state.load.addProvincialReqReject = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProvincialReqReject.rejected, (state, action) => {
        state.load.addProvincialReqReject = loadStatus.error;
        state.error = action.error;
      })
      //Add Provincial Total Reject
      .addCase(addProvincialTotalReqReject.pending, (state) => {
        state.load.addProvincialTotalReqReject = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProvincialTotalReqReject.fulfilled, (state, action) => {
        state.load.addProvincialTotalReqReject = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProvincialTotalReqReject.rejected, (state, action) => {
        state.load.addProvincialTotalReqReject = loadStatus.error;
        state.error = action.error;
      })
      //Add PDO Confirmation Lettor
      .addCase(addPDOLetter.pending, (state) => {
        state.load.addPDOLetter = loadStatus.loading;
        state.error = null;
      })
      .addCase(addPDOLetter.fulfilled, (state, action) => {
        state.load.addPDOLetter = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addPDOLetter.rejected, (state, action) => {
        state.load.addPDOLetter = loadStatus.error;
        state.error = action.error;
      })
      //Add Proposal Phase
      .addCase(addProposalPhase.pending, (state) => {
        state.load.addProposalPhase = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProposalPhase.fulfilled, (state, action) => {
        state.load.addProposalPhase = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProposalPhase.rejected, (state, action) => {
        state.load.addProposalPhase = loadStatus.error;
        state.error = action.error;
      })
      //Add Proposal Basics
      .addCase(addProposalBasics.pending, (state) => {
        state.load.addProposalBasics = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProposalBasics.fulfilled, (state, action) => {
        state.load.addProposalBasics = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProposalBasics.rejected, (state, action) => {
        state.load.addProposalBasics = loadStatus.error;
        state.error = action.error;
      })
      //Add Proposal Background
      .addCase(addProposalBackground.pending, (state) => {
        state.load.addProposalBackground = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProposalBackground.fulfilled, (state, action) => {
        state.load.addProposalBackground = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProposalBackground.rejected, (state, action) => {
        state.load.addProposalBackground = loadStatus.error;
        state.error = action.error;
      })
      //Add Proposal Details
      .addCase(addProposalDetails.pending, (state) => {
        state.load.addProposalDetails = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProposalDetails.fulfilled, (state, action) => {
        state.load.addProposalDetails = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProposalDetails.rejected, (state, action) => {
        state.load.addProposalDetails = loadStatus.error;
        state.error = action.error;
      })
      //Add Proposal Issues
      .addCase(addProposalIssues.pending, (state) => {
        state.load.addProposalIssues = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProposalIssues.fulfilled, (state, action) => {
        state.load.addProposalIssues = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProposalIssues.rejected, (state, action) => {
        state.load.addProposalIssues = loadStatus.error;
        state.error = action.error;
      })
      //Add Proposal Budget
      .addCase(addProposalBudget.pending, (state) => {
        state.load.addProposalBudget = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProposalBudget.fulfilled, (state, action) => {
        state.load.addProposalBudget = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProposalBudget.rejected, (state, action) => {
        state.load.addProposalBudget = loadStatus.error;
        state.error = action.error;
      })
      //Add Proposal Summary
      .addCase(addProposalSummary.pending, (state) => {
        state.load.addProposalSummary = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProposalSummary.fulfilled, (state, action) => {
        state.load.addProposalSummary = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProposalSummary.rejected, (state, action) => {
        state.load.addProposalSummary = loadStatus.error;
        state.error = action.error;
      })
      //Add Community Proposal Approve
      .addCase(addCommunityProposalApprove.pending, (state) => {
        state.load.addCommunityProposalApprove = loadStatus.loading;
        state.error = null;
      })
      .addCase(addCommunityProposalApprove.fulfilled, (state, action) => {
        state.load.addCommunityProposalApprove = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addCommunityProposalApprove.rejected, (state, action) => {
        state.load.addCommunityProposalApprove = loadStatus.error;
        state.error = action.error;
      })
      //Add Community Proposal Reject
      .addCase(addCommunityProposalReject.pending, (state) => {
        state.load.addCommunityProposalReject = loadStatus.loading;
        state.error = null;
      })
      .addCase(addCommunityProposalReject.fulfilled, (state, action) => {
        state.load.addCommunityProposalReject = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addCommunityProposalReject.rejected, (state, action) => {
        state.load.addCommunityProposalReject = loadStatus.error;
        state.error = action.error;
      })
      //Add Community Proposal Total Reject
      .addCase(addCommunityProposalTotalReject.pending, (state) => {
        state.load.addCommunityProposalTotalReject = loadStatus.loading;
        state.error = null;
      })
      .addCase(addCommunityProposalTotalReject.fulfilled, (state, action) => {
        state.load.addCommunityProposalTotalReject = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addCommunityProposalTotalReject.rejected, (state, action) => {
        state.load.addCommunityProposalTotalReject = loadStatus.error;
        state.error = action.error;
      })
      //Add Provincial Proposal Approval
      .addCase(addProvincialProposalApprove.pending, (state) => {
        state.load.addProvincialProposalApprove = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProvincialProposalApprove.fulfilled, (state, action) => {
        state.load.addProvincialProposalApprove = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProvincialProposalApprove.rejected, (state, action) => {
        state.load.addProvincialProposalApprove = loadStatus.error;
        state.error = action.error;
      })
      //Add Provincial Proposal Rejection
      .addCase(addProvincialProposalReject.pending, (state) => {
        state.load.addProvincialProposalReject = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProvincialProposalReject.fulfilled, (state, action) => {
        state.load.addProvincialProposalReject = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProvincialProposalReject.rejected, (state, action) => {
        state.load.addProvincialProposalReject = loadStatus.error;
        state.error = action.error;
      })
      //Add Provincial Proposal Total Rejection
      .addCase(addProvincialProposalTotalReject.pending, (state) => {
        state.load.addProvincialProposalTotalReject = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProvincialProposalTotalReject.fulfilled, (state, action) => {
        state.load.addProvincialProposalTotalReject = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProvincialProposalTotalReject.rejected, (state, action) => {
        state.load.addProvincialProposalTotalReject = loadStatus.error;
        state.error = action.error;
      })
      //Add PDO Proposal Approve
      .addCase(addPDOProposalApprove.pending, (state) => {
        state.load.addPDOProposalApprove = loadStatus.loading;
        state.error = null;
      })
      .addCase(addPDOProposalApprove.fulfilled, (state, action) => {
        state.load.addPDOProposalApprove = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addPDOProposalApprove.rejected, (state, action) => {
        state.load.addPDOProposalApprove = loadStatus.error;
        state.error = action.error;
      })
      //Add Send Donor Proposal Email
      .addCase(donorProposalEmail.pending, (state) => {
        state.load.donorProposalEmail = loadStatus.loading;
        state.error = null;
      })
      .addCase(donorProposalEmail.fulfilled, (state, action) => {
        state.load.donorProposalEmail = loadStatus.success;
        // state.selected = action.payload;
      })
      .addCase(donorProposalEmail.rejected, (state, action) => {
        state.load.donorProposalEmail = loadStatus.error;
        state.error = action.error;
      })
      //Add Send Donor Proposal Email Record
      .addCase(donorProposalEmailRecord.pending, (state) => {
        state.load.donorProposalEmailRecord = loadStatus.loading;
        state.error = null;
      })
      .addCase(donorProposalEmailRecord.fulfilled, (state, action) => {
        state.load.donorProposalEmailRecord = loadStatus.success;
        // state.selected = action.payload;
      })
      .addCase(donorProposalEmailRecord.rejected, (state, action) => {
        state.load.donorProposalEmailRecord = loadStatus.error;
        state.error = action.error;
      })
      //Add Send Donor Proposal Email Follow Up
      .addCase(donorProposalFollowUpEmail.pending, (state) => {
        state.load.donorProposalFollowUpEmail = loadStatus.loading;
        state.error = null;
      })
      .addCase(donorProposalFollowUpEmail.fulfilled, (state, action) => {
        state.load.donorProposalFollowUpEmail = loadStatus.success;
        // state.selected = action.payload;
      })
      .addCase(donorProposalFollowUpEmail.rejected, (state, action) => {
        state.load.donorProposalFollowUpEmail = loadStatus.error;
        state.error = action.error;
      })
      //Add Send Donor Proposal Email Follow Up Record
      .addCase(donorProposalFollowUpEmailRecord.pending, (state) => {
        state.load.donorProposalFollowUpEmailRecord = loadStatus.loading;
        state.error = null;
      })
      .addCase(donorProposalFollowUpEmailRecord.fulfilled, (state, action) => {
        state.load.donorProposalFollowUpEmailRecord = loadStatus.success;
        // state.selected = action.payload;
      })
      .addCase(donorProposalFollowUpEmailRecord.rejected, (state, action) => {
        state.load.donorProposalFollowUpEmailRecord = loadStatus.error;
        state.error = action.error;
      })
      //Add Send Donor Proposal Email Completed
      .addCase(donorProposalEmailCompleted.pending, (state) => {
        state.load.donorProposalEmailCompleted = loadStatus.loading;
        state.error = null;
      })
      .addCase(donorProposalEmailCompleted.fulfilled, (state, action) => {
        state.load.donorProposalEmailCompleted = loadStatus.success;
        // state.selected = action.payload;
      })
      .addCase(donorProposalEmailCompleted.rejected, (state, action) => {
        state.load.donorProposalEmailCompleted = loadStatus.error;
        state.error = action.error;
      })
      //Add Send Donor Proposal Email Follow UP Completed
      .addCase(donorProposalFollowUpEmailCompleted.pending, (state) => {
        state.load.donorProposalFollowUpEmailCompleted = loadStatus.loading;
        state.error = null;
      })
      .addCase(
        donorProposalFollowUpEmailCompleted.fulfilled,
        (state, action) => {
          state.load.donorProposalFollowUpEmailCompleted = loadStatus.success;
          // state.selected = action.payload;
        }
      )
      .addCase(
        donorProposalFollowUpEmailCompleted.rejected,
        (state, action) => {
          state.load.donorProposalFollowUpEmailCompleted = loadStatus.error;
          state.error = action.error;
        }
      )
      //Add or include Donors to project
      .addCase(putIncludeDonor.pending, (state) => {
        state.load.putIncludeDonor = loadStatus.loading;
        state.error = null;
      })
      .addCase(putIncludeDonor.fulfilled, (state, action) => {
        state.load.putIncludeDonor = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(putIncludeDonor.rejected, (state, action) => {
        state.load.putIncludeDonor = loadStatus.error;
        state.error = action.error;
      })
      //Add or include Donors agreements with project
      .addCase(saveDonorAgreements.pending, (state) => {
        state.load.saveDonorAgreements = loadStatus.loading;
        state.error = null;
      })
      .addCase(saveDonorAgreements.fulfilled, (state, action) => {
        state.load.saveDonorAgreements = loadStatus.success;
        // state.selected = action.payload;
      })
      .addCase(saveDonorAgreements.rejected, (state, action) => {
        state.load.saveDonorAgreements = loadStatus.error;
        state.error = action.error;
      })
      //Add Project Expenses
      .addCase(addProjectExpenses.pending, (state) => {
        state.load.addProjectExpenses = loadStatus.loading;
        state.error = null;
      })
      .addCase(addProjectExpenses.fulfilled, (state, action) => {
        state.load.addProjectExpenses = loadStatus.success;
        state.selected = action.payload;
      })
      .addCase(addProjectExpenses.rejected, (state, action) => {
        state.load.addProjectExpenses = loadStatus.error;
        state.error = action.error;
      })
      //Delete Project
      .addCase(deleteProject.pending, (state) => {
        state.load.deleteProject = loadStatus.loading;
        state.error = null;
      })
      .addCase(deleteProject.fulfilled, (state, action) => {
        state.load.deleteProject = loadStatus.success;
        state.data.filter((project) => project.id !== action.meta.arg.id);
      })
      .addCase(deleteProject.rejected, (state, action) => {
        state.load.deleteProject = loadStatus.error;
        state.error = action.error;
      });
  },
});

export const {
  setProjects,
  unsetSelectedProject,
  setSelectedProject,
  unsetProjects,
  setStep,
  setProjectsSize,
} = projectsSlice.actions;
export default projectsSlice.reducer;
